import './DatabaseUpdate.css';
import { useState, useEffect, useContext } from 'react';
import InsertModal from './AddDocumento/index'; // Importa o modal
import FileList from './FileList'; // Importa o componente FileList
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../authContext';

function AddArquivo({ classeCSS, toggleExpand }) {
  
  const { t: tDatabase } = useTranslation('database');
  const [isModalOpen, setIsModalOpen] = useState(false); // Controla a exibição do modal
  const [uploadedFiles, setUploadedFiles] = useState([]); // Lista de arquivos enviados
  const {accessToken, setAccessToken} = useContext(AuthContext);
  const handleOpenModal = () => setIsModalOpen(true); // Abre o modal
  const handleCloseModal = () => setIsModalOpen(false); // Fecha o modal

  // Função para lidar com o upload de arquivos e atualizar a lista
  const handleFileUpload = (fileName) => {
    setUploadedFiles((prevFiles) => [...prevFiles, fileName]);
  };

  // Busca o último arquivo enviado na montagem do componente
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/get_last_meeting`, {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${accessToken}`
      }
    })
      .then((res) => {
        if (!res.ok) throw new Error('Erro ao obter o nome do último arquivo.');
        return res.json();
      })
      .then((data) => {
        const lastFile = data.filename;
        if (lastFile) {
          setUploadedFiles((prevFiles) => [lastFile, ...prevFiles]); // Adiciona o último arquivo à lista
        }
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className={classeCSS} onClick={toggleExpand}>
      <div className="header-database">
        <img src="/imagens/database.svg" alt={tDatabase('databaseIcon')} className="database" />
        <p style={{ marginLeft: '0.8rem', fontSize: '12px', fontWeight: 600 }}>{tDatabase('updateMinutes')}</p>
      </div>

      {/* Botão para abrir o modal */}
      <button className="add-arquivo-button" onClick={handleOpenModal}>
        <img src="imagens/plus-circle.svg" alt={tDatabase('addIcon')} />
        {tDatabase('insert_document')}
      </button>

      {/* Lista de arquivos enviados */}
      <div className="file-list-container">
        <FileList files={uploadedFiles} />
      </div>

      {/* Renderização do modal */}
      {isModalOpen && (
        <InsertModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onFileUpload={handleFileUpload} // Passa a função de upload para o modal
        />
      )}
    </div>
  );
}

export default AddArquivo;
